<template>
    <div>
        <h3 style="margin-top:64px;">Countries we deliver to</h3>
        <p>We deliver to countries in Europe, America, Asia, Africa, Australia and Oceania.</p>
        <img src="/images/british-isles.png" align="left" alt="British Isles" width="110" style="margin-right:10px;">
        <div style="margin-left:140px;">
            <h4>Europe: British Isles</h4>
            <ul>
                <li><a href="https://airoluggage.com/shipping-destinations/guernsey">Guernsey</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/isleofman">Isle of Man</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/ireland">Ireland</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/jersey">Jersey</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/unitedkingdom">United Kingdom</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/ukhighlandsandislands">UK Highlands and Islands</a></li>
                <li><a href="https://airoluggage.com/shipping-destinations/uknorthernireland">UK Northern Ireland</a></li>
            </ul>
        </div>

        <div>
            <img src="/images/western-europe.png" align="left" alt="Western Europe" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Europe: Western Europe</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/belgium">Belgium</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/germany">Germany</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/france">France</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/liechtenstein">Liechtenstein</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/luxembourg">Luxembourg</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/monaco">Monaco</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/netherlands">Netherlands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/austria">Austria</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/switzerland">Switzerland</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/northern-europe.png" align="left" alt="Northern Europe" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Europe: Northern Europe</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/alandislands">Åland Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/denmark">Denmark</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/estonia">Estonia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/faroeislands">Faroe Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/finland">Finland</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/iceland">Iceland</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/latvia">Latvia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/lithuania">Lithuania</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/norway">Norway</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/sweden">Sweden</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/svalbard">Svalbard</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/eastern-europe.png" align="left" alt="Eastern Europe" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Europe: Eastern Europe</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/belarus">Belarus</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bulgaria">Bulgaria</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/moldova">Moldova</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/poland">Poland</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/romania">Romania</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/russia">Russia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/slovakia">Slovakia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/czechia">Czechia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/ukraine">Ukraine</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/hungary">Hungary</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/southern-europe.png" align="left" alt="Southern Europe" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Europe: Southern Europe</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/albania">Albania</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/andorra">Andorra</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bosniaandherzegovina">Bosnia and Herzegovina</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/gibraltar">Gibraltar</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/greece">Greece</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/italy">Italy</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/kosovo">Kosovo</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/croatia">Croatia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/malta">Malta</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/montenegro">Montenegro</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/northmacedonia">North Macedonia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/portugal">Portugal</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/sanmarino">San Marino</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/serbia">Serbia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/slovenia">Slovenia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/spain">Spain</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/holysee">Holy See (Vatican City)</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/canada.png" align="left" alt="North America" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>America: North America</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/canada">Canada</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/unitedstates">United States (USA)</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/central-america.png" align="left" alt="Central America" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>America: Central America</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/belize">Belize</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/costarica">Costa Rica</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/elsalvador">El Salvador</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/guatemala">Guatemala</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/honduras">Honduras</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mexico">Mexico</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/nicaragua">Nicaragua</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/panama">Panama</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/south-america.png" align="left" alt="South America" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>America: South America</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/argentina">Argentina</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bolivia">Bolivia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/brazil">Brazil</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/chile">Chile</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/colombia">Colombia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/ecuador">Ecuador</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/falklandislands">Falkland Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/frenchguiana">French Guiana</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/guyana">Guyana</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/paraguay">Paraguay</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/peru">Peru</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/suriname">Suriname</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/uruguay">Uruguay</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/caribbean.png" align="left" alt="Caribbean" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>America: Caribbean</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/anguilla">Anguilla</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/antiguaandbarbuda">Antigua and Barbuda</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/aruba">Aruba</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bahamas">Bahamas</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/barbados">Barbados</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bermuda">Bermuda</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/britishvirginislands">British Virgin Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/caymanislands">Cayman Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/dominica">Dominica</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/dominicanrepublic">Dominican Republic</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/grenada">Grenada</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/guadeloupe">Guadeloupe</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/haiti">Haiti</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/jamaica">Jamaica</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/martinique">Martinique</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/montserrat">Montserrat</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/puertorico">Puerto Rico</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/saintkittsandnevis">Saint Kitts and Nevis</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/saintlucia">Saint Lucia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/stvincentandthegrenadines">St Vincent and the Grenadines</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/trinidadandtobago">Trinidad and Tobago</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/turksandcaicos">Turks and Caicos</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/usvirginislands">US Virgin Islands</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/western-asia.png" align="left" alt="Western Asia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Asia: Western Asia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/armenia">Armenia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/azerbaijan">Azerbaijan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bahrain">Bahrain</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/georgia">Georgia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/iraq">Iraq</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/israel">Israel</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/yemen">Yemen</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/jordan">Jordan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/kuwait">Kuwait</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/qatar">Qatar</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/lebanon">Lebanon</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/saudiarabia">Saudi Arabia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/unitedarabemirates">United Arab Emirates</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/cyprus">Cyprus</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/central-asia.png" align="left" alt="Central Asia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Asia: Central Asia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/kazakhstan">Kazakhstan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/kyrgyzstan">Kyrgyzstan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tajikistan">Tajikistan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/uzbekistan">Uzbekistan</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/south-asia.png" align="left" alt="South Asia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Asia: South Asia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/afghanistan">Afghanistan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bangladesh">Bangladesh</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/bhutan">Bhutan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/india">India</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/nepal">Nepal</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/pakistan">Pakistan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/srilanka">Sri Lanka</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/southeast-asia.png" align="left" alt="Southeast Asia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Asia: Southeast Asia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/brunei">Brunei</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/indonesia">Indonesia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/malaysia">Malaysia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/philippines">Philippines</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/singapore">Singapore</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/thailand">Thailand</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/vietnam">Vietnam</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/east-asia.png" align="left" alt="East Asia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Asia: East Asia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/china">China</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/hongkong">Hong Kong</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/japan">Japan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/macao">Macao</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mongolia">Mongolia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/southkorea">South Korea</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/taiwan">Taiwan</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/cambodia">Cambodia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/laos">Laos</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/maldives">Maldives</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/myanmar">Myanmar</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/western-africa.png" align="left" alt="Western Africa" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Africa: Western Africa</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/benin">Benin</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/burkinafaso">Burkina Faso</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/capeverde">Cape Verde</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/cotedivoire">Cote D\'Ivoire</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/gambia">Gambia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/ghana">Ghana</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mali">Mali</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/nigeria">Nigeria</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/senegal">Senegal</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/sierraleone">Sierra Leone</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/togo">Togo</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/northern-africa.png" align="left" alt="Northern Africa" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Africa: Northern Africa</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/egypt">Egypt</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/algeria">Algeria</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/morocco">Morocco</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tunisia">Tunisia</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/southern-africa.png" align="left" alt="Southern Africa" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Africa: Southern Africa</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/botswana">Botswana</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/namibia">Namibia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/southafrica">South Africa</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/central-africa.png" align="left" alt="Central Africa" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Africa: Central Africa</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/angola">Angola</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/burundi">Burundi</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/cameroon">Cameroon</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/congo">Democratic Republic of the Congo</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/republicofthecongo">Republic of the Congo</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/chad">Chad</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/equatorialguinea">Equatorial Guinea</a></li> 
                    <li><a href="https://airoluggage.com/shipping-destinations/gabon">Gabon</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/rwanda">Rwanda</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/eastern-africa.png" align="left" alt="Eastern Africa" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Africa: Eastern Africa</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/ethiopia">Ethiopia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/eritrea">Eritrea</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/kenya">Kenya</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/madagascar">Madagascar</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/malawi">Malawi</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mauritius">Mauritius</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mayotte">Mayotte</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/mozambique">Mozambique</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/reunion">Reunion</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/zambia">Zambia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/zimbabwe">Zimbabwe</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tanzania">Tanzania</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/uganda">Uganda</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/australia.png" align="left" alt="Australia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Australia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/newzealand">New Zealand</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/australia">Australia</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/melanesia.png" align="left" alt="Melanesia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Oceania: Melanesia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/fiji">Fiji</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/newcaledonia">New Caledonia</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/papuanewguinea">Papua New Guinea</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/solomonislands">Solomon Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/vanuatu">Vanuatu</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/micronesia.png" align="left" alt="Micronesia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Oceania: Micronesia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/kiribati">Kiribati</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/nauru">Nauru</a></li>
                </ul>
            </div>
        </div>

        <div>
            <img src="/images/polynesia.png" align="left" alt="Polynesia" width="110" style="margin-right:10px;">
            <div style="margin-left:140px;">
                <h4>Oceania: Polynesia</h4>
                <ul>
                    <li><a href="https://airoluggage.com/shipping-destinations/americansamoa">American Samoa</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/cookislands">Cook Islands</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/niue">Niue</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/samoa">Samoa</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tokelau">Tokelau</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tonga">Tonga</a></li>
                    <li><a href="https://airoluggage.com/shipping-destinations/tuvalu">Tuvalu</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://airoluggage.com/lpshipping/countries-served'}
    ]
  },
};
</script>
